import React from "react";
import PropTypes from "prop-types";

const TcCollapsedLogo = ({ className, size = 18 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      d="M91 143 C88 143 86 146 86 149 L86 169 C86 173 89 176 93 176 L142 176 L142 349 C142 354 146 357 151 357 L173 357 C178 357 181 354 181 349 L181 176 L231 176 C235 176 238 173 238 169 L238 150 C238 146 235 143 231 143 Z"
    />
    <path
      fill="currentColor"
      d="M348 142 C315 142 290 151 274 171 C258 191 253 218 253 250 C253 284 259 312 275 332 C291 351 316 359 349 359 C360 359 371 358 381 356 C385 355 387 352 387 348 L387 331 C387 326 384 324 379 324 L344 325 C326 325 313 319 305 307 C296 294 293 276 293 250 C293 224 296 206 305 193 C313 181 326 176 344 176 L379 176 C384 176 387 173 387 168 L386 151 C386 147 384 145 380 144 C370 143 359 142 348 142 Z"
    />
  </svg>
);

TcCollapsedLogo.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number
};

export default TcCollapsedLogo;
